// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 378) return "js/chunk.378.b765a960.js";
	if (chunkId === 830) return "js/chunk.830.a1367c70.js";
	// return url for filenames based on template
	return undefined;
};